module.exports = __webpack_public_path__ + "img/PointAtoB.97545482.png";